<template>
  <div>
    <user-add
      user-title="供应商" user-add-url="/user/supply/add"
    ></user-add>
    <el-table :data="Cdata"  height="80vh">
      <el-table-column label="" fixed="left" width="160">
        <template slot-scope="scope" >
          <el-image class="item-image" :src="'http://'+Cdata[scope.$index].logoUrl" alt=""></el-image>
        </template>
      </el-table-column>
      <el-table-column label="ID" width="50" prop="id"></el-table-column>
      <el-table-column label="公司名称" prop="companyName" ></el-table-column>
      <el-table-column label="背景颜色" prop="colour">

      </el-table-column>
      <el-table-column label="创建时间" prop="createTime" ></el-table-column>
      <el-table-column label="更新时间" prop="updateTime" ></el-table-column>
      <el-table-column label="操作" width="160" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleLook(Cdata[scope.$index].id)">查看</el-button>
          <el-button type="text" size="small" @click="handleChange(Cdata[scope.$index].id)">修改</el-button>
          <el-button type="text" size="small" @click="handleDelete(Cdata[scope.$index].id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      class="page"
      :page-size="1"
      style="margin-top:15px;"
      @current-change="handleCurrentChange"
      :total="Cpage"
      layout="prev, pager, next"
    > </el-pagination>
  </div>
</template>

<script>
  import UserDetailTitle from "../Common/UserDetailTitle";
  import UserAdd from "../Common/UserAdd";
  export default {
    name: "SupplyBase",
    components: {UserAdd, UserDetailTitle},
    data(){
      return{
        Cdata:null,//当前表格展示数据
        Cpage:null,//当前获取数据总页数
        PostData:{
          'pageNumber':0,
          'pageSize':20,
        }
      }
    },
    created() {
      this.GetData(this.PostData)

    },
    methods:{
      GetData(PageData){
        this.$axios.post('/api/supplier/getList',PageData).then(res=>{
          this.Cdata=res.data.data.records
          this.Cpage=res.data.data.pages
        })
      },
      handleCurrentChange(index){
        this.PostData.pageNumber=index;
        this.GetData(this.PostData)
      },
      handleLook(id){
        this.$router.push('/user/supply/look'+id)
      },
      handleChange(id){
        this.$router.push('/user/supply/change'+id)
      },
      Delete(id){
        this.$axios.delete('/api/supplier/deleteById/'+id).then(res=>{
          this.GetData(this.PostData)
        })
      },
      handleDelete(id){
        this.$confirm('确定删除该条信息', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.Delete(id)
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
    }
  }
</script>

<style scoped>

</style>